import React from 'react';

const SearchIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.49935 0.666992C3.28756 0.666992 0.666016 3.28854 0.666016 6.50033C0.666016 9.71212 3.28756 12.3337 6.49935 12.3337C7.95601 12.3337 9.28686 11.7903 10.3112 10.9014L10.666 11.2562V12.3337L15.666 17.3337L17.3327 15.667L12.3327 10.667H11.2552L10.9004 10.3122C11.7894 9.28783 12.3327 7.95699 12.3327 6.50033C12.3327 3.28854 9.71114 0.666992 6.49935 0.666992ZM6.49935 2.33366C8.81041 2.33366 10.666 4.18927 10.666 6.50033C10.666 8.81138 8.81041 10.667 6.49935 10.667C4.18829 10.667 2.33268 8.81138 2.33268 6.50033C2.33268 4.18927 4.18829 2.33366 6.49935 2.33366Z" fill="currentColor" />
  </svg>
);

export default SearchIcon;
